import { Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { QuestionnaireAnswers } from '@types-lib';
import { TooltipDirective, UiInfoIconDirective } from '@ui-components';

@Component({
  selector: 'answer-display',
  imports: [DatePipe, TooltipDirective, UiInfoIconDirective],
  templateUrl: './answer-display.component.html',
  styleUrls: ['../../_styles/index.scss', './answer-display.component.scss'],
})
export class AnswerDisplayComponent {
  question = input<string>();
  answers = input<QuestionnaireAnswers.DisplayAnswer[]>();
}
